import { render, staticRenderFns } from "./MaintenanceFooter.vue?vue&type=template&id=24143530"
import script from "./MaintenanceFooter.vue?vue&type=script&lang=js"
export * from "./MaintenanceFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports